module.exports = __webpack_public_path__ + "static/media/DINNextCYR-Bold.4179858b.woff";